module.exports = __webpack_public_path__ + "static/img/yjf.3fdb010b.png";